export default import.meta.ROLLDOWN_FILE_URL_eVdoCWCwuvNpyew3U9aj$w